import { Directive, EventEmitter, Input, Output } from '@angular/core';
import {admin, analyst, background, deficiency, doesNotQualify, intake, DashboardAdmin } from './queue-status-filter.constant';

@Directive({
  standalone: false,
  selector: '[queueStatusFilter]'
})
export class QueueStatusFilterDirective {
  @Output() filteredDataChange = new EventEmitter<any[]>();

  @Input('queueStatusFilter') queueName: string;
  @Input() data: any[];
  cleanedFiltered: any[] = [];

  get filteredData(): any[] {
    if (!this.data || !this.queueName) return [];
    const statusArray: string[] = [];
    const isAdminQueue = this.queueName?.toLowerCase() === 'admin' || this.queueName?.toLowerCase() === 'background' || this.queueName?.toLowerCase() === 'dashboardadmin';
    let filteredData: any[] = [];
    if (isAdminQueue) {
      filteredData = this.data;
    } else {
      filteredData = this.data.filter(item => item.is_archived === false ||item.is_archived === null || item.is_archived === undefined || item.is_archived === '---');
    }
      let rules: QueueRule[] = [];
    switch (this.queueName?.toLowerCase()) {
      case 'intake':
        rules = intake;
        break;
      case 'deficiency':
        rules = deficiency;
        break;
      case 'analyst':
        rules = analyst;
        break;
      case 'doesnotqualify':
        rules = doesNotQualify;
        break;
      case 'admin':
        rules = admin;
        break;
      case 'dashboardadmin':
        rules = DashboardAdmin;
        break;
      case 'background':
        rules = background;
        break;
      default:
        rules = [];
    }

    if (filteredData) {
      filteredData = filteredData.filter(item => {
        const cd_application_status = this.queueName?.toLowerCase() === 'dashboardadmin'
          ? (item.cd_application_status ? item.cd_application_status : '')
          : (item.application_status ? item.application_status : '');
 
        const background_check_status = item.background_check_status ? item.background_check_status: '-';
        const application_type = item.application_type ? item.application_type : '';
        return rules.some(rule => {
        if (rule.appStatus !== cd_application_status) {
          return false;
        }
        if(application_type == 'Surrender' ){
          if(this.queueName?.toLowerCase() == 'analyst' || this.queueName?.toLowerCase() == 'admin' || this.queueName?.toLowerCase() == 'dashboardadmin'){
            if (!rule.bgStatus || rule.bgStatus.length === 0) {
                item.application_status = rule.applicationStatus;
                return true;
              }
            else{
              return false;
            }
          }else{
            return false;
          }
        }
        if(item.bg_required === true){
          if (rule.bgStatus.includes('-')) {
            return true;
          }
          if(rule.bgStatus.includes(background_check_status)){
            item.application_status = rule.applicationStatus;
            return  true;
          }
          if(this.queueName?.toLowerCase() === 'dashboardadmin' && rule.bgStatus.length === 0){
            item.application_status = rule.applicationStatus;
            return true;
          }
        }else{
          if(cd_application_status === '17' && (this.queueName?.toLowerCase() === 'intake' || this.queueName?.toLowerCase() === 'admin' || this.queueName?.toLowerCase() === 'dashboardadmin')){
            item.application_status = rule.applicationStatus;
            return true;
          }
          else if (!rule.bgStatus || rule.bgStatus.length === 0) {
              item.application_status = rule.applicationStatus;
              return true;
            }
        }
      });
      });
    }
    this.nullValueHandler(filteredData);
    this.filteredDataChange.emit(this.cleanedFiltered);
    this.cleanedFiltered.forEach(item => {
      const isBgArchived =
        String(item.cd_case_archived) === '2'
      item.archive = isBgArchived ? "Archived" : "Active";
    });
    return this.cleanedFiltered;
  }

  nullValueHandler(value: any): any {
   const sortedFiltered = value.sort((a, b) => {
    if(this.queueName?.toLowerCase() === 'dashboardadmin'){
      const dateA = new Date(a.created_date || 0).getTime();
      const dateB = new Date(b.created_date || 0).getTime();
      return dateA - dateB;
    }else{
      const dateA = new Date(a.submission_date || a.date_submitted || 0).getTime();
      const dateB = new Date(b.submission_date || b.date_submitted || 0).getTime();
      return dateA - dateB;
    }
    });
    this.cleanedFiltered = sortedFiltered.map(item => {
      const newItem = { ...item };
      Object.keys(newItem).forEach(key => {
        if (
          newItem[key] === null ||
          newItem[key] === '' ||
          newItem[key] === undefined ||
          newItem[key] === 'null' ||
          (typeof newItem[key] === 'string' && newItem[key].trim() === '')
        ) {
          newItem[key] = '---';
        }
      });
      return newItem;
    });
  }
}
interface QueueRule {
  appStatus: string
  bgStatus: string[] // ['Pending'] or ['-'] for "any"
  applicationStatus: string
}